import React, {Component} from 'react';

/**
 * 输入框
 */
class Input extends Component {
  static defaultProps = {
    placeholder: undefined,
    value: '',
    icon: '',
    style: undefined,
    type: 'text',
    maxLength: 100,
    error: '',
    onChange: (v) => {
    },
    onEnter: () => {
    }
  };

  render() {
    const {placeholder, icon, value, type, maxLength, error, onChange, onEnter, style} = this.props;
    return (
      <div className={'input-wrap ' + (error ? 'error' : '')} style={{...style}}>
        <div style={{position: "relative", height: '100%',}}>
          <input type={type} className="input" placeholder="&nbsp;" value={value} maxLength={maxLength}
                 onKeyUp={(e) => {
                   if (e.keyCode === 13 && onEnter) {
                     onEnter();
                   }
                 }}
                 onChange={(e) => {
                   if (onChange) onChange(e.target.value);
                 }}/>
          <span className="label">{placeholder}{error &&
          <span style={{color: 'red', marginLeft: 6}}>*{error}</span>}
          </span>
        </div>
        <div>
          <img src={icon} alt='' style={{position: 'absolute', right: 12, top: 28, width: 12}}/>
        </div>
      </div>
    );
  }
}

Input.propTypes = {};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.js